"use client";
import { Box } from "@chakra-ui/react";
import { forwardRef } from "react";
import { Wrapper, WrapperProps } from "./wrapper";

export interface PlaceProps extends WrapperProps {
  label: string;
}

export const PlaceSearchOption = forwardRef<HTMLDivElement, PlaceProps>(
  (props: PlaceProps, ref) => {
    const { label, ...rest } = props;
    return (
      <Wrapper ref={ref} {...rest}>
        <Box flex="1" ml="4">
          <Box fontWeight="semibold">{label}</Box>
        </Box>
      </Wrapper>
    );
  },
);

export default PlaceSearchOption;
